export const buildDeclineOnHoldPayload = declineReason => {
  if (declineReason.trim()) return { decline_reason: declineReason.trim() }

  return {}
}
